module.exports = __webpack_public_path__ + "static/media/tab_inner1.b4e66614.png";